<template>
  <transition name="fade">
    <div class="mod-req-app-50">
      <div class="mod-req-app-container">
        <div>
          <div>Email</div>
          <input type="text" class="input-100" v-model="email" />
        </div>
      </div>
      <div class="multy-btn-center mt-10">
        <div class="flex-space-around">
          <div
            class="btn-small"
            v-if="$get($store, 'state.approvalSheet.reviewState') == 6"
          >
            <div class="btn-wrapper btn-wrapper__red" @click="cancelResend()">
              Cancel
            </div>
          </div>
          <div
            class="btn-small"
            v-if="$get($store, 'state.approvalSheet.reviewState') == 6"
          >
            <div class="btn-wrapper btn-wrapper__red" @click="sendEmail()">
              Send Email
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      email: '',
    }
  },
  methods: {
    async sendEmail() {
      this.$store.dispatch('approvalSheet/reSendEmailK3l', {
        note: this.email,
        user_id: this.$get(this.$store, 'state.userid'),
        id: this.$get(this.$store, 'state.approvalSheet.request_id'),
      })
    },
    cancelResend() {
      this.$store.commit('modalReqApp/SET_VALUE', {
        name: 'modalResendEmailK3l',
        value: false,
      })
    },
  },
}
</script>
